<div
  class="outer"
>
  <h2>
    Password

    <a
      class="button small white indigo"
      target="_blank"
      [href]="MOTION_ARTICLE_PASSWORD"
    >
      Learn about Motion Passwords
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
    </a>
  </h2>

  <div
    class="password"
  >
    <div>
      <input
        [(ngModel)]="password1"
        type="password"
      >
      <div class="label">Enter new password</div>
    </div>
    <div>
      <input
        [(ngModel)]="password2"
        type="password"
      >
      <div class="label">Confirm new password</div>
    </div>
  </div>

  <button
    (click)="attemptChangePassword()"
    [ngClass]="{
      'loading': passwordChanging,
      'inactive': !password2
    }"
  >
    <span>Change Password</span>
    <motn-spinner></motn-spinner>
  </button>
</div>

<div
  class="outer"
>
  <h2>
    Two-Factor Authentication (2FA)

    <a
      class="button small white indigo"
      target="_blank"
      [href]="MOTION_ARTICLE_2FA"
    >
      Learn about Motion 2FA
      <i class="fa-solid fa-arrow-up-right-from-square"></i>
    </a>
  </h2>

  <div>
    @if (!twoFactorAuthEnabled) {
      <button
        class="green"
        (click)="promptEnableTwoFactorAuth()"
      >
        Enable 2FA
      </button>
    }

    @if (twoFactorAuthEnabled) {
      <button
        class="red"
        (click)="promptDisableTwoFactorAuth()"
      >
        Disable 2FA
      </button>
    }
  </div>
</div>

@if (twoFactorDrawerOpen) {
  <motn-drawer-gap-from-top
    (clickedOutside$)="closeTwoFactorDrawer()"
    [loading]="!totpSetup"
  >
    <h2>
      2FA Setup

      <a
        class="button small white indigo"
        target="_blank"
        [href]="MOTION_ARTICLE_2FA"
      >
        Learn about Motion 2FA
        <i class="fa-solid fa-arrow-up-right-from-square"></i>
      </a>
    </h2>

    <div
      class="outer"
    >

      <h3>
        Step 1
      </h3>

      @if (totpSetup) {
        <div
          class="totp-setup"
        >
          <div
            class="inner"
          >
            <div
              class="label"
            >
              Method 1: Scan QR Code (recommended)
            </div>

            <div>
              <img [src]=totpImgSrc [alt]="$safeNavigationMigration(totpSetup?.Secret)"/>
            </div>
          </div>

          <div
            class="inner"
          >
            <div
              class="label"
            >
              Method 2: Manually Enter Setup Key
            </div>
            <div
              class="monospace"
              (touchstart)=writeKeyToClipboard()
              (click)=writeKeyToClipboard()
            >
              {{totpSetup.Secret}}
            </div>

            @if (codeCopied) {
              <div
                class="copied"
              >
                <i class="far fa-check"></i> Copied
              </div>
            }
          </div>
        </div>
      }

      <h3>
        Step 2
      </h3>

      <input
        placeholder="e.g. 668466"
        type=tel
        (keyup.enter)=validateTwoFactorAuthCode()
        [(ngModel)]=totpConfirmCode
      >

      <div
        class="label"
      >
        TOTP Validation Code
      </div>

      <button
        (click)="validateTwoFactorAuthCode()"
        [ngClass]="{
          'green': 1,
          'loading': twoFactorAuthValidating,
          'inactive': !totpConfirmCode
        }"
      >
        <span>Validate</span>
        <motn-spinner></motn-spinner>
      </button>
    </div>
  </motn-drawer-gap-from-top>
}
